<template>
  <v-fab-transition>
      <v-btn
        v-scroll="onScroll"
        v-show="showToTop"
        color="white z-index-2"
        small
        dark
        fixed
        bottom
        class="mb-n2"
        elevation="20"
        fab
        right
        @click.native="toTop"
      >
        <v-icon large color="blue accent-4">mdi-chevron-up</v-icon>
      </v-btn>
    </v-fab-transition>
</template>

<script>
export default {
data:() =>({
    showToTop: false,
}),
methods: {
    onScroll(e) {
      if (typeof window === "undefined") return;
      const top = window.pageYOffset || e.target.scrollTop || 0;
      this.showToTop = top > 20;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
},
}
</script>

<style>

</style>